// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import { createContext } from 'react'
import { UploadFile as _UploadFile } from 'antd'
import { modelInputProps } from '../Interfaces'

interface contextProps {
  clicks: [clicks: modelInputProps[], setClicks: (e: modelInputProps[]) => void]
  image: [image: HTMLImageElement | null, setImage: (e: HTMLImageElement | null) => void]
  maskImg: [maskImg: HTMLImageElement | null, setMaskImg: (e: HTMLImageElement | null) => void]
  resultMask: [
    resultMask: HTMLImageElement | null,
    setResultMask: (e: HTMLImageElement | null) => void
  ]
  resultHighlightMask: [
    resultHighlightMask: HTMLImageElement | null,
    setResultHighlightMask: (e: HTMLImageElement | null) => void
  ]
  clipData: [clipData: any | null, setClipData: (e: any | null) => void]
  stickers: [stickers: any[], setStickers: (e: any[]) => void]
  segmentType: [segmentType: string | null, setSegmentType: (e: string | null) => void]
  currentImage: [currentImage: string | null, setCurrentImage: (e: string | null) => void]
  currentImageIndex: [
    currentImageIndex: number | null,
    setCurrentImageIndex: (e: number | null) => void
  ]
  currentImageData: [
    currentImageData: ImageData | null,
    setCurrentImageData: (e: ImageData | null) => void
  ]
  overCircle: [overCircle: number | null, setOverCircle: (e: number | null) => void]
  clickType: [clickType: number, setClickType: (e: number) => void]
  isReset: [isReset: boolean, setIsReset: (e: boolean) => void]
  canvasWidth: [canvasWidth: number, setCanvasWidth: (e: number) => void]
  canvasHeight: [canvasHeight: number, setCanvasHeight: (e: number) => void]
  everythingMask: [everythingMask: any[], setEverythingMask: (e: any[]) => void]
  isEverythingRemoved: [isEverythingRemoved: boolean, setIsEverythingRemoved: (e: boolean) => void]
  isLoading: [isLoading: boolean, setIsLoading: (e: boolean) => void]
  isChanging: [isChanging: boolean, setIsChanging: (e: boolean) => void]
  isSaving: [isSaving: boolean, setIsSaving: (e: boolean) => void]
}

const SegmentContext = createContext<contextProps | null>(null)

export default SegmentContext
